var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.584.453a1.338 1.338 0 00-2.007 0L7.896 14.267 2.423 8.305a1.338 1.338 0 00-2.007 0 1.645 1.645 0 000 2.187l6.476 7.055c.277.302.64.453 1.004.453a1.36 1.36 0 001.004-.453L22.585 2.64a1.646 1.646 0 000-2.187z",
    fill: "#18AA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.584 1.453a1.338 1.338 0 00-2.007 0L16.896 15.267l-5.473-5.962a1.338 1.338 0 00-2.007 0 1.645 1.645 0 000 2.187l6.476 7.055c.277.302.64.453 1.004.453.363 0 .726-.151 1.004-.453L31.585 3.64a1.646 1.646 0 000-2.187z",
    fill: "#18AA52"
  })));
}

export default SvgCheckSuccess;